mutation PurchaseOrderExportFilter($input: PurchaseOrderExportFilterInput!) {
  purchaseOrderExportFilter(input: $input) {
    exportResult {
      exportCycles
    }
  }
}
